import React from 'react';
import { LuPencil, LuTrash2 } from 'react-icons/lu';

import { TaxFilingV2 } from '@ndvr/portfolio-api';

import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { formatDate, titleCase } from 'utils';

interface TaxFilingCardProps {
    filing: TaxFilingV2;
    isActive?: boolean;
    showDeleteButton: boolean;
    onEdit: (filing: TaxFilingV2, isActive: boolean) => void;
    onDelete: (e: React.MouseEvent, filing: TaxFilingV2) => void;
}

export const TaxFilingCard = ({ filing, isActive = false, showDeleteButton, onEdit, onDelete }: TaxFilingCardProps) => {
    const handleEdit = (e: React.MouseEvent) => {
        e.stopPropagation();
        onEdit(filing, isActive);
    };

    return (
        <Card key={filing.taxFilingGUID} className="group relative border-b p-4">
            <div className="absolute top-2 right-2 flex gap-1 opacity-0 transition-opacity group-hover:opacity-100">
                <Button variant="ghost" size="icon" className="h-8 w-8" onClick={handleEdit}>
                    <LuPencil className="h-4 w-4 text-gray-500 hover:text-blue-600" />
                </Button>
                {showDeleteButton && (
                    <Button variant="ghost" size="icon" className="h-8 w-8" onClick={(e) => onDelete(e, filing)}>
                        <LuTrash2 className="h-4 w-4 text-gray-500 hover:text-red-600" />
                    </Button>
                )}
            </div>
            <div className="text-cocoa-1000 font-medium">{filing.title.plainText}</div>
            <div className="text-sm text-gray-600">{titleCase(filing.taxFilingStatus)}</div>
            <div className="text-sm text-gray-600">Effective: {formatDate(filing.effectiveFrom)}</div>
        </Card>
    );
};
